import { useQuery } from "@apollo/client";
import { parseError } from "apollo";
import Errors from "components/base/Errors";
import SearchBar from "components/base/SearchBar";
import Spinner from "components/base/Spinner";
import gql from "graphql-tag";
import { useState } from "react";
import { searchByProp } from "utils/search";

const FETCH_CUSTOMERS = gql`
  query fetchCustomers {
    customers {
      id
      name
      odooPartnerId
    }
  }
`;

function CustomersSelector({ initialSearchText = "", onSelect, odooOnly }) {
  const [searchText, setSearchText] = useState(initialSearchText);
  const { loading, error, data } = useQuery(FETCH_CUSTOMERS);

  if (loading) return <Spinner />;
  if (error) return <Errors error={parseError(error)} />;

  const customersToShow = data.customers
    .filter((i) => searchByProp(i, ["name", "email"], searchText))
    .filter((i) => (odooOnly ? i.odooPartnerId !== null : true));

  return (
    <div className="text-sm">
      <SearchBar
        autoFocus={true}
        className="py-2"
        type="text"
        placeholder="Search customer by name or email"
        value={searchText}
        onChange={setSearchText}
      />

      {odooOnly && (
        <div className=" opacity-70 text-xs mt-2 px-1">
          Only customers connected to Odoo will be shown.
        </div>
      )}

      <div className="mt-4 flex-1 overflow-auto card p-0">
        {customersToShow.length > 0 ? (
          <table>
            <tbody>
              {customersToShow.map((customer, key) => (
                <tr
                  className="cursor-pointer hover:bg-blue-100 dark:hover:bg-blue-900"
                  key={key}
                  onClick={() => onSelect(customer)}
                >
                  <td className="py-2 px-4 border-b border-gray-100 dark:border-gray-800">
                    {customer.name}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="flex flex-col items-center justify-center p-8">
            <div className="text-lg opacity-70 mb-4">No customers found.</div>
          </div>
        )}
      </div>
    </div>
  );
}

export default CustomersSelector;
